import React, { SyntheticEvent } from 'react';
import { CmsAsset } from '../../integrations/contentful/types';
import H from '../elements/H';
import {
  baseXInPixels,
  baseXUnit,
  imageHoverOpacity
} from '../../styles/theme';
import Spacing from '../common/Spacing';
import CmsMedia from '../cms/CmsMedia';
import DivButton from '../a11y/DivButton';
import Paragraph from '../elements/Paragraph';
import DisplayOn from '../common/DisplayOn';
import CmsMediaFixedHeight from '../cms/CmsMediaFixedHeight';

interface ExperiencePhaseCardProps {
  cardTitle: string;
  mainImage: CmsAsset;
  description: string;
  onClick: (event: SyntheticEvent) => void;
}

const imageHeightBase = 26;
const imageWidthBase = 38;

function clipContent(description: string) {
  return `”${description.slice(0, 45)} ...`;
}
const ExperiencePhaseCard: React.FunctionComponent<ExperiencePhaseCardProps> =
  ({ cardTitle, mainImage, description, onClick }) => {
    return (
      <div className="experience-phase-card" data-cy="experience-phase-card">
        <DivButton data-testid="experience-phase-card" onClick={onClick}>
          <Spacing bottom={1}>
            <DisplayOn small medium>
              <CmsMedia
                media={mainImage}
                width={baseXInPixels(imageWidthBase)}
                height={baseXInPixels(imageHeightBase)}
                borderRadius={1}
                crop
              />
            </DisplayOn>
            <DisplayOn large>
              <CmsMediaFixedHeight
                media={mainImage}
                fixedHeight={[14, 14, 14, 18]}
                borderRadius={1}
              />
            </DisplayOn>
          </Spacing>
          <Spacing bottom={1}>
            <H tag="h4" styling="h4">
              <strong>{cardTitle}</strong>
            </H>
          </Spacing>
          <Paragraph small data-testid="description">
            {clipContent(description)}
          </Paragraph>
        </DivButton>
        {/*language=CSS*/}
        <style jsx>{`
          .experience-phase-card {
            padding-bottom: ${baseXUnit(2)};
          }
          .experience-phase-card:hover :global(.cms-video),
          .experience-phase-card:hover :global(img) {
            opacity: ${imageHoverOpacity};
          }
          strong {
            line-height: normal;
          }
        `}</style>
      </div>
    );
  };

export default ExperiencePhaseCard;
